import React, { useEffect, useRef, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "animate.css";
import "./Assets/css/all.min.css";
import "./Assets/css//main-style.css";
import "./Assets/css/responsive-media.css";
import "./Assets/css/jquery-ui.min.css";
import Home from "../src/Pages/Home";
import About from "../src/Pages/About";
import Contact from "../src/Pages/Contact";
import Blog from "../src/Pages/Blog";
import Header from "../src/Components/Header/Navbar";
import Footer from "../src/Components/Footer/Footer";
import ProductDetails from "./Pages/ProductDetails";
import NotFound from "./Pages/NotFound";
import ScrollToTop from "./Components/ScrollButton/ScrollToTop";
import BlogDetails from "./Components/Blog/BlogDetails/BlogDetails";
import TermsConditions from "./Pages/TermsConditions";
import { Toaster } from "react-hot-toast";
import Category from "./Pages/Category";
import UserProfile from "./Components/Account/UserProfile";
import MyAddress from "./Components/Account/MyAddress";
import MyOrder from "./Components/Account/MyOrder";
import Wishlist from "./Components/Account/Wishlist";
import Compare from "./Components/Account/Compare";
import useAuth from "./Features/Utils/useAuth";
import ViewCart from "./Components/ShoppingCart/ViewCart";
import ViewCheckout from "./Components/ShoppingCart/ViewCheckout";
import PaymentPage from "./Components/ShoppingCart/PaymentPage";
import OrderConfirmation from "./Components/ShoppingCart/OrderConfirmation";
import OrderFailed from "./Components/ShoppingCart/OrderFailed";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  return children;
};

const App = () => {
  const [loginOpen, setLoginOpen] = useState(false);
  const dropdownRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        !event.target.closest(".user-icon")
      ) {
        setTimeout(() => setLoginOpen(false), 100);
      }
    };

    if (loginOpen) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [loginOpen]);

  return (
    <div id="main">
      <ScrollToTop />

      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/category/:categorySlug" element={<Category />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/product/:productSlug" element={<ProductDetails />} />
        <Route path="/BlogDetails" element={<BlogDetails />} />
        <Route path="/terms" element={<TermsConditions />} />
        <Route path="/cart" element={<ViewCart />} />
        <Route
          path="/order-confirmation"
          element={
            <ProtectedRoute>
              <OrderConfirmation />
            </ProtectedRoute>
          }
        />
        <Route
          path="/order-failed"
          element={
            <ProtectedRoute>
              <OrderFailed />
            </ProtectedRoute>
          }
        />
        <Route
          path="/checkout"
          element={
            <ProtectedRoute>
              <ViewCheckout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/payment"
          element={
            <ProtectedRoute>
              <PaymentPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/user-profile"
          element={
            <ProtectedRoute>
              <UserProfile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/my-address"
          element={
            <ProtectedRoute>
              <MyAddress />
            </ProtectedRoute>
          }
        />
        <Route
          path="/order"
          element={
            <ProtectedRoute>
              <MyOrder />
            </ProtectedRoute>
          }
        />
        <Route
          path="/wishlist"
          element={
            <ProtectedRoute>
              <Wishlist />
            </ProtectedRoute>
          }
        />
        <Route
          path="/compare"
          element={
            <ProtectedRoute>
              <Compare />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
      <Toaster />
    </div>
  );
};

export default App;
